<template>
  <el-container class="index-con">
    <el-container class="main-con">
      <el-header class="index-header">
        <topnav @exitlogin="exit2('btn')"> </topnav
      ></el-header>
      <el-main
        class="index-main"
        :style="{
          paddingTop: myRoute == '/index' || myRoute == '/search-map' ? '' : '6%',
        }"
      >
        <router-view ref="routerView"></router-view>
      </el-main>
    </el-container>

    <!-- 全局双击放大图片,全局用法：$store.commit('set_dbClickImg',src) -->
    <el-image-viewer
      v-if="dbClickImg.show"
      :on-close="close_dbClickImgBox"
      :url-list="[dbClickImg.src]"
    />
    <!-- 全局双击放大视频,全局用法：$store.commit('set_enlargeDv',src) -->
    <div v-show="enlargeDv.show">
      <video
        @dblclick="$store.commit('set_enlargeDv', '')"
        class="u-position-absolute"
        style="
          z-index: 9998;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          height: 100%;
        "
        :src="enlargeDv.src"
        muted
        autoplay
      ></video>
    </div>
    <!--  控制弹窗：
    this.$store.commit('boxDetail', {
              data: response.data,
              title: '详情',
              api: 'POST_hyEnterpriseUpdate',
              uploadImgApi: this.$apis.POST_hyEnterpriseUploadImg,
              sort: this.sortName
            });
    逻辑控制关闭：this.$store.commit('boxDetail', null); -->
    <el-dialog
      :title="boxDetail ? boxDetail.title : '标题'"
      :visible.sync="bool"
      width="60%"
      @closed="closedDialog"
      custom-class="my-car-detail car_dialog"
    >
      <car-details
        v-if="boxDetail"
        :show4CardIndex="boxDetail.showCard"
        :detail="boxDetail"
      ></car-details>
    </el-dialog>
  </el-container>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
// 导入组件
import CarDetails from "@/components/carDetails.vue";

import ElImageViewer from "@/components/CustomImageViewer";
import eventList from "@/components/event-warn/event-list.vue";
import topnav from "@/views/layout/topnav.vue";
import webconfig from "@/web.config.js";
export default {
  name: "index",
  data() {
    return {
      bool: false,
      sevenDaysCount: 0,
      isBackTime: false,
      saveTimer: null,
      myEvent: null,
      pageTypeStr: "",
      refreshNum: 3,
      showDialogRefresh: false,
      locationUrl: "",
      topCountData: {},
      top_wsData: {},
      currentPage: false,
      websock: null,
      timeout: 60 * 1000 * 5, // 5分钟一次心跳
      timeoutCount: 0, // 心跳异常计数
      // serverTimeoutObj: null, // 心跳倒计时
      timeoutnum: null, // 断开 重连倒计时
      saveStartTimer: null,
      itemName: "",
      SecondaryMenu: "",
      showclass: "asideshow",
      showtype: false,
      myRoute: "",
    };
  },
  components: {
    CarDetails,
    ElImageViewer,
    topnav,
    eventList,
  },
  computed: {
    ...mapState({
      boxDetail: (state) => state.detail.boxDetail,
      dbClickImg: (state) => state.dbClickImg,
      enlargeDv: (state) => state.enlargeDv,
      eventListBox: (state) => state.eventListBox,
    }),
    // ...mapGetters(["GET_USERINFO"]),
    showEventList() {
      return webconfig.showEventList && this.eventListBox.show;
    },
  },
  methods: {
    ...mapMutations(["set_bigData_last_date", "SET_USERINFO"]),
    ...mapActions({
      setDictionary: "ACT_SET_DICTIONARY", // 将 `this.setDictionary()` 映射为 `this.$store.dispatch('ACT_SET_DICTIONARY')`
    }),
    close_dbClickImgBox() {
      //全局双击放大图片
      this.$store.commit("set_dbClickImg", "");
    },
    exit2(msg) {
      this.currentPage = true;
      this.$store.dispatch("user/logout").then((res) => {
        window.localStorage.setItem('storageAside', '0')
        window.localStorage.setItem('menu', [])
        this.$message({
          type: "success",
          message: "--已退出登录!--",
        });
        this.$router.push("/J3Klogin");
      });
    },
    closedDialog() {
      if (this.boxDetail) this.$store.commit("boxDetail", null);
    },
  },
  mounted() {
    this.myRoute = this.$route.path;
  },
  created() {},
  watch: {
    boxDetail(nval) {
      if (nval) this.bool = true;
      else this.bool = false;
    },
    $route(to) {
      this.myRoute = to.path;
    },
  },
};
</script>
<style lang="scss">
.index-con {
  .my-car-detail {
    margin-top: 5vh !important;
  }
  .index-main {
    > div {
      height: 91%;
      box-sizing: border-box;
    }
  }
  .el-breadcrumb__inner {
    color: #fff !important ;
    font-weight: bold !important;
  }
  .el-breadcrumb__inner a,
  .el-breadcrumb__inner.is-link {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue